import type { Http } from '../http';
import { endpoints } from '../endpoints';
import type { RequestOptions } from '../types/common';
import type { RawInstallCompanyListParams, RawInstallCompanyListResponse } from '../types/company';

export function createCompanyApi(http: Http) {
  return {
    /** GET /api/v2/companies/installs — 설치회사 목록(이름 오름차순, 페이징 없음). */
    async listInstalls(
      params?: RawInstallCompanyListParams,
      options?: RequestOptions,
    ): Promise<RawInstallCompanyListResponse> {
      const res = await http.get<RawInstallCompanyListResponse>(endpoints.company.installs, {
        params,
        signal: options?.signal,
      });
      return res.data;
    },
  };
}
